import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {PostPayloadInterface} from '../../models/post-payload.interface';
import {SuperRepoRepository} from './super-repo.repository';
import {FilterService} from "../../services/filterer/filter.service";
import {Dtos} from "../../utils/dtos";

@Injectable({
  providedIn: 'root'
})
export class CoreDataRepository extends SuperRepoRepository{
  constructor(public httpClient: HttpClient, private filterService:FilterService) {
    super();
    this.httpClient=httpClient;
  }
  getFilterListByKey(key:string){
    const path = 'dashboard/admin/core-'+key+'/new';
    const filter =this.filterService.filter(Dtos.CORE_DATA[key]).equal('deleted', false).create();
    const options = {params: new HttpParams().append('filter', JSON.stringify(filter))};
    return super.get(path, options);
  }
  getFilterListByKeySynch(key:string){
    const path = 'dashboard/admin/core-'+key+'/new';
    const filter =this.filterService.filter(Dtos.CORE_DATA[key]).equal('deleted', false).create();
    const options = {params: new HttpParams().append('filter', JSON.stringify(filter))};
    return super.get(path, options).toPromise();
  }
  getAllListByKey(key:string){
    const path = 'dashboard/admin/core-'+key+'/new';
    const filter =this.filterService.filter(Dtos.CORE_DATA[key]).create();
    const options = {params: new HttpParams().append('filter', JSON.stringify(filter))};
    return super.get(path,options);
  }

  deleteById(_coreDataKey: string, id: any) {
    const path = 'dashboard/admin/core-'+_coreDataKey+'/'+id;
    return super.delete(path);
  }
  reactivateById(_coreDataKey: string, id: any) {
    const path = 'dashboard/admin/core-'+_coreDataKey+'/'+id+'/reactivate';
    return super.patch(path);
  }

  update(_coreDataKey: string, coreData: PostPayloadInterface) {
    const path = 'dashboard/admin/core-'+_coreDataKey+'/'+coreData.id;
    return super.put(path, coreData);
  }

  save(_coreDataKey: string, coreData: PostPayloadInterface) {
    const path = 'dashboard/admin/core-'+_coreDataKey;
    return super.post(path, coreData)
  }


}
